module.exports = __webpack_public_path__ + "img/swipe4-icon.c062ffef.png";